import Vue from "vue";


// for permission
import permissionDirectives from "@/plugins/permission";
Vue.use(permissionDirectives);

import App from "./App.vue";
import VueRouter from "vue-router";
import IdleVue from "idle-vue";
import ZoomOnHover from "vue-zoom-on-hover";
Vue.use(VueRouter);
Vue.use(ZoomOnHover);

// Set cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies, { expires: "1d" });


//layouts file
Vue.component(
  "auth-layout",
  () => import("@/components/admin/layouts/main_layout/AuthLayout.vue"),
);
Vue.component(
  "default-layout",
  () => import("@/components/admin/layouts/main_layout/DefaultLayout.vue"),
);
Vue.component(
  "standapp-layout",
  () => import("@/components/admin/layouts/main_layout/Standapp.vue"),
);
Vue.component(
  "auth-v2-layout",
  () => import("@/components/admin/layouts/main_layout/AuthV2Layout.vue"),
);
Vue.component(
  "standapp-v2-layout",
  () => import("@/components/admin/layouts/main_layout/StandappV2.vue"),
);
Vue.component(
  "customer-layout",
  () => import("@/components/admin/layouts/main_layout/CustomerHomeLayout.vue"),
);
Vue.component(
  "simple-layout",
  () => import("@/components/admin/layouts/simple/SimpleLayout.vue"),
);

//BootstrapVue
import { BootstrapVue } from "bootstrap-vue";
Vue.use(BootstrapVue);
// Date filter
import "../src/plugins/datetimefilter";

//axios
import axios from "axios";
Vue.prototype.$http = axios;
import store from "./store";

//encrypt & decrypt
import VueCryptojs from "vue-cryptojs";
Vue.use(VueCryptojs);

// Declare base url
let APP_HOST = window.location.origin.toString();
if (process.env.VUE_APP_NODE_URL?.startsWith("http")) {
  APP_HOST = process.env.VUE_APP_NODE_URL;
} else {
  APP_HOST = APP_HOST + process.env.VUE_APP_NODE_URL;
}
console.log("🚀 ~ file: main.js ~ line 50 ~ APP_HOST", APP_HOST);
Vue.prototype.$baseurl = APP_HOST;
Vue.prototype.$apiV2 = process.env.VUE_APP_PYTHON_URL;
Vue.prototype.$standapp = process.env.VUE_APP_STANDAPP_URL;
Vue.prototype.$payangel = process.env.VUE_APP_PAYANGEL_URL;
Vue.prototype.$apiV2transaction = process.env.VUE_APP_PYTHON_TRANSACTION_URL;

// to generate static token for api
Vue.prototype.$username = process.env.VUE_APP_STANDAPP_URL_USERNAME;
Vue.prototype.$password = process.env.VUE_APP_STANDAPP_URL_PASSWORD;

const routes = [
  //front routes
  {
    path: "/analytics",
    name: "Analytics",
    component: () => 
      import(
        "./components/admin/analytics/AnalyticsProComponent.vue"
      ),
    meta: { title: "Analytics", layout: "default", requiresAuth: true, menu: "analytics", permissions: ["analytics.view"], }
  },
  {
    path: "/daily-transaction-tracker",
    name: "DailyTransactionTracker",
    component: () =>
      import(
        "./components/admin/analytics/DailyTransactionTracker.vue"
      ),
    meta: { title: "Daily Transaction", layout: "default", requiresAuth: true, menu: "dailytransaction", permissions: ["dailytransaction.view"] }
  },
  {
    path: "/holds",
    name: "Holds",
    component: () =>
      import(
        "./components/admin/holds/HoldsListComponent.vue"
      ),
    meta: { title: "Holds", breadCrumb: "Holds", layout: "default", requiresAuth: true, menu: "risk", permissions: ["hold.view", "hold.confirm", "hold.reverse"] }
  },
  {
    path: "/statements",
    name: "Statements",
    component: () =>
      import(
        "./components/admin/statement/StatementComponent.vue"
      ),
    meta: { title: "Statements", breadCrumb: "Statements", layout: "default", requiresAuth: true, menu: "statement", permissions: ["statement.view", "statement.generate"] }
  },
  {
    path: "",
    redirect: "/page-login",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/components/admin/home/HomeComponent.vue"),
    meta: { title: "Home Page", layout: "auth-v2" },
  },
  {
    path: "/page-login",
    name: "login",
    component: require("@/components/admin/authentication/LoginComponent.vue")
      .default,
    meta: { title: "Login", layout: "auth", requiresAuth: false },
  },
  {
    path: "/set-password",
    name: "ssetpassword",
    component:
      require("@/components/admin/authentication/StandappSetPasswordComponent.vue")
        .default,
    meta: { title: "Set Password", layout: "auth" },
  },
  {
    path: "/forgot-password",
    name: "sforgotpassword",
    component:
      require("@/components/admin/authentication/ForgotPasswordComponent.vue")
        .default,
    meta: { title: "Forgot Password", layout: "auth" },
  },
  {
    path: "/reset-password",
    name: "sresetpassword",
    component:
      require("@/components/admin/authentication/ResetPasswordComponent.vue")
        .default,
    meta: { title: "Reset Password", layout: "auth" },
  },
  {
    path: "/recover-password",
    name: "srecoverpassword",
    component:
      require("@/components/admin/authentication/RecoverPasswordComponent.vue")
        .default,
    meta: { title: "Recover Password", layout: "auth" },
  },
  {
    path: "/dashboard",
    component: () =>
      import("@/components/admin/dashboard/DashboardComponent.vue"),
    meta: { title: "Dashboard", breadCrumb: "Dashboard", requiresAuth: true, menu: "dashboard", permissions: ["dashboard.view"]},
  },
  {
    path: "/dashboard-v1",
    component: () =>
      import("@/components/admin/dashboard/DashboardV1Component.vue"),
    meta: { breadCrumb: "Dashboard", title: "Dashboard", requiresAuth: true },
  },
  {
    path: "/business",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Business", title: "Business", requiresAuth: true },
    children: [
      {
        path: "list",
        component: require("@/components/admin/business/BusinessComponent.vue")
          .default,
        meta: {
          breadCrumb: "Business List",
          title: "Business List",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.view"],
        },
      },
      {
        path: "analytics",
        name: "BusinessAnalytics",
        component: () =>
          import(
            "@/components/admin/business/analytics/BusinessAnalyticsComponent.vue"
          ),
        meta: {
          breadCrumb: "Business Analytics",
          title: "Business Analytics",
          requiresAuth: true,
          // The backend's allowed menus are permission modules; businessanalytics.view is in "business".
          menu: "business",
          permissions: ["businessanalytics.view"],
        },
      },
      {
        path: "details",
        component:
          require("@/components/admin/business/BusinesDetailComponent.vue")
            .default,
        meta: {
          breadCrumb: "Business Details",
          title: "Business Details",
          requiresAuth: true,
        },
      },
      {
        path: "subsidiaries-detail",
        component:
          require("@/components/admin/business/SubsidiariesDetailComponent.vue")
            .default,
        meta: {
          breadCrumb: "Subsidiaries Details",
          title: "Subsidiaries Details",
          requiresAuth: true,
        },
      },
      {
        path: ":businessid/financials",
        name: "BusinessFinancials",
        component: () =>
          import("@/components/admin/business/BusinessFinancials.vue"),
        meta: {
          breadCrumb: "Business Financials",
          title: "Business Financials",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.view"],
        },
      },
      {
        path: ":businessid/transactions/:transactionId",
        name: "BusinessTransactionDetail",
        component: () =>
          import("@/components/admin/business/BusinessTransactionDetail.vue"),
        meta: {
          breadCrumb: "Transaction Detail",
          title: "Transaction Detail",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.view"],
        },
      },
    ],
  },
  {
    path: "/offers",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Offers", title: "Offers", requiresAuth: true },
    children: [
      {
        path: "list",
        component: require("@/components/admin/offers/OffersListComponent.vue").default,
        meta: {
          breadCrumb: "Offers List",
          title: "Offers List",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.view"],
        },
      },
      {
        path: "add",
        component: require("@/components/admin/offers/AddOfferComponent.vue").default,
        meta: {
          breadCrumb: "Create Offer",
          title: "Create Offer",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.status"],
        },
      },
      {
        path: "edit/:id?",
        name: "offer-edit",
        component: require("@/components/admin/offers/EditOfferComponent.vue").default,
        meta: {
          breadCrumb: "Edit Offer",
          title: "Edit Offer",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.status"],
        },
      },
      {
        path: "details/:id?",
        name: "offer-details",
        component: require("@/components/admin/offers/OfferDetailComponent.vue").default,
        meta: {
          breadCrumb: "Offer Details",
          title: "Offer Details",
          requiresAuth: true,
          menu: "business",
          permissions: ["business.view"],
        },
      },
    ],
  },
  {
    path: "/onboarding",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Onboarding", title: "Onboarding", requiresAuth: true },
    children: [
      {
        path: "submissions",
        component: () =>
          import("@/components/admin/onboarding/SubmissionsQueue.vue"),
        meta: {
          breadCrumb: "Submissions Queue",
          title: "Submissions Queue",
          requiresAuth: true,
        },
      },
      {
        path: "assigned",
        component: () =>
          import("@/components/admin/onboarding/SubmissionsQueue.vue"),
        meta: {
          breadCrumb: "Assigned to Me",
          title: "Assigned to Me",
          requiresAuth: true,
        },
        props: { assignedToMe: true },
      },
      {
        path: "submissions/:submissionId",
        name: "SubmissionDetail",
        component: () =>
          import("@/components/admin/onboarding/SubmissionDetail.vue"),
        meta: {
          breadCrumb: "Submission Detail",
          title: "Submission Detail",
          requiresAuth: true,
        },
      },
      {
        path: "document-requirements",
        component: () =>
          import("@/components/admin/onboarding/DocumentRequirementsConfig.vue"),
        meta: {
          breadCrumb: "Document Requirements",
          title: "Document Requirements",
          requiresAuth: true,
        },
      },
      {
        path: "document-types",
        component: () =>
          import("@/components/admin/onboarding/DocumentTypesConfig.vue"),
        meta: {
          breadCrumb: "Document Types",
          title: "Document Types",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/customer",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Customer", title: "Customer", requiresAuth: true },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/customer/CustomerListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Remitter List",
          title: "Remitter List",
          requiresAuth: true,
          menu: "remitters",
          permissions: ["remitter.view"],
        },
      },
      {
        path: "edit/:customer_id?",
        name: "customer-edit",
        component:
          require("@/components/admin/customer/EditCustomer/EditCustomer.vue")
            .default,
        meta: {
          breadCrumb: "Edit Remitter",
          title: "Edit Remitter",
          requiresAuth: true,
          menu: "remitters",
          permissions: ["remitter.edit"],
        },
      },
      {
        path: "fresh-customer",
        name: "fresh-customer",
        component:
          require("@/components/admin/customer/FreshCustomerListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Fresh Customer",
          title: "Fresh Customer",
          requiresAuth: true,
        },
      },
      {
        path: "enable-fields",
        component:
          require("@/components/admin/customer/EnableFieldsComponent.vue")
            .default,
        meta: {
          breadCrumb: "Enable Edit Profile",
          title: "Enable Edit Profile",
          requiresAuth: true,
          menu: "remitters",
          permissions: ["remitter.enable"],
        },
      },
      {
        path: "pending-document-review",
        component:
          require("@/components/admin/documentupload/PendingDocumentReview.vue")
            .default,
        meta: {
          breadCrumb: "Pending Document Review",
          title: "Pending Document Review",
          requiresAuth: true,
        },
      },
      {
        path: "annual-reviews",
        name: "annual-reviews",
        component: require("@/components/admin/customer/annual-review/AnnualReviewsQueue.vue")
          .default,
        meta: {
          breadCrumb: "Annual Review",
          title: "Annual Information Review",
          requiresAuth: true,
          menu: "remitters",
          permissions: ["remitter.view"],
        },
      },
      {
        path: "annual-reviews/:review_id",
        name: "annual-review-detail",
        component: require("@/components/admin/customer/annual-review/AnnualReviewDetail.vue")
          .default,
        meta: {
          breadCrumb: "Annual Review Detail",
          title: "Annual Review Detail",
          requiresAuth: true,
          menu: "remitters",
          permissions: ["remitter.view"],
        },
      },
      {
        path: "customer-ip-blacklist",
        component:
          require("@/components/admin/customer/CustomerIPBlacklist.vue")
            .default,
        meta: {
          breadCrumb: "Customer IP Blacklist",
          title: "Customer IP Blacklist",
          requiresAuth: true,
        },
      },
      {
        path: "customer-ip-blacklist/add",
        component:
          require("@/components/admin/customer/AddCustomerIPBlacklist.vue")
            .default,
        meta: {
          breadCrumb: "Add Customer IP Blacklist",
          title: "Add Customer IP Blacklist",
          requiresAuth: true,
        },
      },
      {
        path: "customer-ip-blacklist/edit",
        component:
          require("@/components/admin/customer/EditCustomerIPBlacklist.vue")
            .default,
        meta: {
          breadCrumb: "Edit Customer IP Blacklist",
          title: "Edit Customer IP Blacklist",
          requiresAuth: true,
        },
      },
      {
        path: "round-blocking",
        component:
          require("@/components/admin/customer/RoundBlockingComponent.vue")
            .default,
        meta: {
          breadCrumb: "Round Blocking",
          title: "Round Blocking",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/accounts",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Accounts", title: "Accounts", requiresAuth: true },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/accounts/AccountListComponent.vue")
            .default,
        meta: { breadCrumb: "List", title: "List", requiresAuth: true, menu: "accounts", permissions: ["bank.view","momo.view"] },
      },
      {
        path: "edit",
        component:
          require("@/components/admin/accounts/EditAccountComponent.vue")
            .default,
        meta: { breadCrumb: "Edit", title: "Edit", requiresAuth: true },
      },
    ],
  },
  {
    path: "/document-upload/link/:document_id?",
    name: "document-upload-link",
    component:
      require("@/components/admin/documentupload/GenerateDocumentUploadLink.vue")
        .default,
    meta: { layout: "simple", title: "Customer", requiresAuth: true },
  },
  {
    path: "/beneficiary",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Receivers", title: "Receivers", requiresAuth: true },
    children: [
      {
        path: "list/:customer_id?",
        name: "beneficiary-list",
        component:
          require("@/components/admin/customer/BeneficiaryListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Receivers List",
          title: "Receivers List",
          requiresAuth: true,
        },
      },
      {
        path: "all",
        name: "beneficiary-all",
        component:
          require("@/components/admin/customer/AllBeneficiaryComponent.vue")
            .default,
        meta: {
          breadCrumb: "All Receivers List",
          title: "All Receivers List",
          requiresAuth: true,
          menu: "receivers",
          permissions: ["receiver.view"],
        },
      },
      {
        path: "edit/:beneficiary_id?/:customer_id?/:country_id?",
        name: "beneficiary-edit",
        component:
          require("@/components/admin/customer/EditBeneficiaryComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit Receiver",
          title: "Edit Receiver",
          requiresAuth: true,
          menu: "receivers",
          permissions: ["receiver.edit"],
        },
      },
      {
        path: "linked-remitters/:beneficiary_id?/:customer_id?/:country_id?",
        name: "beneficiary-linked-remitters",
        component: require("@/components/admin/customer/LinkedRemitterPage.vue")
          .default,
        meta: {
          breadCrumb: "Receiver Details",
          title: "Receiver Details",
          requiresAuth: true,
          menu: "receivers",
          permissions: ["receiver.details"],
        },
      },
    ],
  },
  {
    path: "/transaction",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Transaction",
      title: "Transaction",
      requiresAuth: true,
    },
    children: [
      {
        path: "arch",
        component:
          require("@/components/admin/transaction/TransactionListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Transaction List",
          title: "Transaction List",
          requiresAuth: true,
        },
      },
      {
        path: "details/:ref_no?/:transaction_id?",
        name: "transaction-details",
        component:
          require("@/components/admin/transaction/TransactionDetailComponent.vue")
            .default,
        meta: {
          breadCrumb: "Transaction Details",
          title: "Transaction Details",
          requiresAuth: true,
          // ENG-2348 — shared by all three views, so it accepts any cadre's details
          // permission. `menu` is deliberately omitted: the guard checks it as a single
          // value against allowedMenuItems, which no one string can satisfy for all
          // three cadres. The permission check below is the real gate, and the API
          // scopes the transaction itself.
          permissions: [
            "transaction.details",
            "treasurytransaction.details",
            "businesstransaction.details",
          ],
        },
      },
      {
        path: "edit",
        component:
          require("@/components/admin/transaction/TransactionEditComponent.vue")
            .default,
        meta: {
          breadCrumb: "Transaction Edit",
          title: "Transaction Edit",
          requiresAuth: true,
        },
      },
      // ENG-2348 — one component, three team-owned views. `meta.team` is the only
      // difference: it selects the column/action profile in the component and is sent
      // to the API as `team`, which the server authorises against the caller's view
      // permission before applying the scope. The path stays /transaction/middleware
      // for CE so existing bookmarks and findAccessibleRoute keep working.
      {
        path: "middleware",
        component:
          require("@/components/admin/transaction/MiddlewareTransactionListComponent.vue")
            .default,
        meta: {
          breadCrumb: "CE Transactions",
          title: "CE Transactions",
          requiresAuth: true,
          menu: "transaction",
          permissions: ["transaction.view"],
          team: "ce",
        },
      },
      {
        path: "treasury",
        component:
          require("@/components/admin/transaction/MiddlewareTransactionListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Treasury Transactions",
          title: "Treasury Transactions",
          requiresAuth: true,
          menu: "treasurytransaction",
          permissions: ["treasurytransaction.view"],
          team: "treasury",
        },
      },
      {
        path: "business",
        component:
          require("@/components/admin/transaction/MiddlewareTransactionListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Business Transactions",
          title: "Business Transactions",
          requiresAuth: true,
          menu: "businesstransaction",
          permissions: ["businesstransaction.view"],
          team: "business",
        },
      },
      {
        path: "card-monitoring",
        component:
          require("@/components/admin/transaction/CardMonitoringComponent.vue")
            .default,
        meta: {
          breadCrumb: "Card Monitoring",
          title: "Card Monitoring",
          requiresAuth: true,
        },
      },
      {
        path: "cash-collection",
        component:
          require("@/components/admin/transaction/CashCollectionComponent.vue")
            .default,
        meta: {
          breadCrumb: "Cash Collection",
          title: "Cash Collection",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/fx-rates",
    component: require("@/components/admin/fx-rates/FxRatesComponent.vue")
      .default,
    meta: {
      breadCrumb: "FX Rates",
      title: "FX Rates Management",
      requiresAuth: true,
      menu: "fxrates",
      permissions: ["fxrates.view"],
    },
  },
  {
    path: "/fx-rates/quick-update",
    component:
      require("@/components/admin/fx-rates/QuickRateUpdateComponent.vue")
        .default,
    meta: {
      breadCrumb: "Quick Rate Update",
      title: "Quick Rate Update",
      requiresAuth: true,
      menu: "fxrates",
      permissions: ["fxrates.update"],
    },
  },
  {
    path: "/fx-rates/csv-upload",
    component: require("@/components/admin/fx-rates/CsvUploadComponent.vue")
      .default,
    meta: {
      breadCrumb: "CSV Upload",
      title: "CSV File Upload",
      requiresAuth: true,
      menu: "fxrates",
      permissions: ["fxrates.csvupload"],
    },
  },
  {
    path: "/internal-users",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Internal Users",
      title: "Internal Users",
      requiresAuth: true,
    },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/internal_users/UserListComponent.vue")
            .default,
        meta: {
          breadCrumb: "User Management",
          title: "Internal User Management",
          requiresAuth: true,
          menu : "users",
          permissions : ["users.view"]
        },
      },
    ],
  },
  {
    path: "/internal-user-roles",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Internal User Roles",
      title: "Internal User Roles",
      requiresAuth: true,
    },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/internal_users/UserRoleListComponent.vue")
            .default,
        meta: {
          breadCrumb: "User Role Management",
          title: "Internal User Role Management",
          requiresAuth: true,
          menu: "roles",
          permissions: ["roles.view"],
        },
      },
    ],
  },

  {
    path: "/partner",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Partner", title: "Partner", requiresAuth: true },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/partner/PartnerListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Partner List",
          title: "Partner List",
          requiresAuth: true,
        },
      },
      {
        path: "add",
        component: require("@/components/admin/partner/AddPartnerComponent.vue")
          .default,
        meta: {
          breadCrumb: "Add Partner",
          title: "Add Partner",
          requiresAuth: true,
        },
      },
      {
        path: "edit",
        component:
          require("@/components/admin/partner/EditPartnerComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit Partner",
          title: "Edit Partner",
          requiresAuth: true,
        },
      },
      {
        path: "users",
        component: require("@/components/admin/partner/ManagePartnerUsers.vue")
          .default,
        meta: {
          breadCrumb: "Manage Users",
          title: "Manage Users",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/remitter-credit",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Remitter Credit",
      title: "Remitter Credit",
      requiresAuth: true,
    },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/remitterCredit/RemitterCreditComponent.vue")
            .default,
        meta: {
          breadCrumb: "List",
          title: "Remitter Credit",
          requiresAuth: true,
        },
      },
      {
        path: "create",
        component:
          require("@/components/admin/remitterCredit/CreateRemitterCreditComponent.vue")
            .default,
        meta: {
          breadCrumb: "Create",
          title: "Remitter Credit Create",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/reports",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Reports", title: "Reports", requiresAuth: true },
    children: [
      {
        path: "transaction-reports",
        component:
          require("@/components/admin/reports/TransactionReportComponent.vue")
            .default,
        meta: {
          breadCrumb: "Transaction Reports",
          title: "Transaction reports",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/send-promotional-email",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Send Promotional Email",
      title: "Send Promotional Email",
      requiresAuth: true,
    },
    children: [
      {
        path: "single-remitter",
        component:
          require("@/components/admin/sendPromotionalEmail/SingleRemitterEmailComponent.vue")
            .default,
        meta: {
          breadCrumb: "Single Remitter",
          title: "Single Remitter",
          requiresAuth: true,
        },
      },
      {
        path: "single-remitter/send",
        component:
          require("@/components/admin/sendPromotionalEmail/SendSingleRemitterEmail.vue")
            .default,
        meta: {
          breadCrumb: "Single Remitter Notification",
          title: "Single Remitter Notification",
          requiresAuth: true,
        },
      },
      {
        path: "group-remitter",
        component:
          require("@/components/admin/sendPromotionalEmail/GroupRemitterEmailComponent.vue")
            .default,
        meta: {
          breadCrumb: "Group Remitter",
          title: "Group Remitter",
          requiresAuth: true,
        },
      },
      {
        path: "group-remitter/send",
        component:
          require("@/components/admin/sendPromotionalEmail/SendGroupRemitterEmail.vue")
            .default,
        meta: {
          breadCrumb: "Group Remitter Notification",
          title: "Group Remitter Notification",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/validate-bank-account",
    component: () =>
      import("@/components/admin/bank/ValidateBankComponent.vue"),
    meta: {
      breadCrumb: "Validate Bank Account",
      title: "Validate Bank Account",
      requiresAuth: true,
    },
  },
  {
    path: "/user",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "User", title: "User", requiresAuth: true },
    children: [
      {
        path: "list",
        component: require("@/components/admin/user/ListComponent.vue").default,
        meta: {
          breadCrumb: "User List",
          title: "User List",
          requiresAuth: true,
        },
      },
      {
        path: "add",
        component: require("@/components/admin/user/AddComponent.vue").default,
        meta: { breadCrumb: "Add User", title: "Add User", requiresAuth: true },
      },
    ],
  },
  {
    path: "/cms",
    redirect: "cms/list",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    children: [
      {
        path: "list",
        component: require("@/components/admin/cms/CmsListComponent.vue")
          .default,
        meta: { breadCrumb: "CMS List", title: "CMS List", requiresAuth: true },
      },
      {
        path: "add",
        component: require("@/components/admin/cms/AddCmsComponent.vue")
          .default,
        meta: { breadCrumb: "Add CMS", title: "Add CMS", requiresAuth: true },
      },
      {
        path: "edit",
        component: require("@/components/admin/cms/EditCmsComponent.vue")
          .default,
        meta: { breadCrumb: "Edit CMS", title: "Edit CMS", requiresAuth: true },
      },
    ],
  },
  {
    path: "/country",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "Country", title: "Country", requiresAuth: true },
    children: [
      {
        path: "list",
        component: require("@/components/admin/country/ListComponent.vue")
          .default,
        meta: { breadCrumb: "List", title: "Country List", requiresAuth: true, menu: "country", permissions: ["country.view"]},
      },
      {
        path: "details",
        component:
          require("@/components/admin/country/CountryDetailComponent.vue")
            .default,
        meta: {
          breadCrumb: "Details",
          title: "Country Details",
          requiresAuth: true,
          menu: "country",
          permissions: ["country.details"]
        },
      },
    ],
  },

  {
    path: "/list",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: { breadCrumb: "List", title: "List", requiresAuth: true },
    children: [
      {
        path: "payout-option",
        component: () => import("@/components/admin/list/PayoutComponent.vue"),
        meta: {
          breadCrumb: "Payout Option",
          title: "Payout Option",
          requiresAuth: true,
        },
      },
      {
        path: "payment-option",
        component: () => import("@/components/admin/list/PaymentComponent.vue"),
        meta: {
          breadCrumb: "Payment Option",
          title: "Payment Option",
          requiresAuth: true,
        },
      },
      {
        path: "service-type",
        component: () =>
          import("@/components/admin/list/ServiceTypeComponent.vue"),
        meta: {
          breadCrumb: "Service Type",
          title: "Service Type",
          requiresAuth: true,
        },
      },
      {
        path: "bank",
        component: () => import("@/components/admin/list/BankComponent.vue"),
        meta: {
          breadCrumb: "Bank List",
          title: "Bank List",
          requiresAuth: true,
        },
      },
      {
        path: "provider",
        component: () =>
          import("@/components/admin/list/BankWiseProviderList.vue"),
        meta: {
          breadCrumb: "Provider List",
          title: "Provider List",
          requiresAuth: true,
        },
      },
      {
        path: "benificiary-relationship",
        component: () =>
          import("@/components/admin/list/BenificiaryRelationComponent.vue"),
        meta: {
          breadCrumb: "Benificiary Relationship",
          title: "Benificiary Relationship",
          requiresAuth: true,
        },
      },
      {
        path: "business-relationship",
        component: () =>
          import("@/components/admin/list/BusinessRelationshipComponent.vue"),
        meta: {
          breadCrumb: "Business Relationship",
          title: "Business Relationship",
          requiresAuth: true,
        },
      },
      {
        path: "remitter-group-management/list",
        component:
          require("@/components/admin/remitterGroup/RemitterGroupManagement.vue")
            .default,
        meta: {
          breadCrumb: "Remitter Group list",
          title: "Remitter Group List",
          requiresAuth: true,
        },
      },
      {
        path: "remitter-group-management/add",
        component:
          require("@/components/admin/remitterGroup/AddRemitterGroupComponent.vue")
            .default,
        meta: {
          breadCrumb: "Add Remitter Group",
          title: "Add Remitter Group",
          requiresAuth: true,
        },
      },
      {
        path: "bin-listing",
        component: () =>
          import("@/components/admin/list/binlisting/BinListingComponent.vue"),
        meta: {
          breadCrumb: "Bin Listing",
          title: "Bin Listing",
          requiresAuth: true,
        },
      },
      {
        path: "add-bin-listing",
        component: () =>
          import("@/components/admin/list/binlisting/CreateBinNumber.vue"),
        meta: {
          breadCrumb: "Add Bin List",
          title: "Add Bin List",
          requiresAuth: true,
        },
      },
      {
        path: "edit-bin-listing",
        component: () =>
          import("@/components/admin/list/binlisting/EditBinNumber.vue"),
        meta: {
          breadCrumb: "Edit Bin List",
          title: "Edit Bin List",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/remitone-rates",
    component: () =>
      import("@/components/admin/remitone_rates/RemitOneLiveRates.vue"),
    meta: {
      breadCrumb: "RemitOne Live Rates",
      title: "RemitOne Live Rates",
      requiresAuth: true,
    },
  },
  {
    path: "/remitone-fees",
    component: () =>
      import("@/components/admin/remitone_fees/RemitOneLiveFees.vue"),
    meta: {
      breadCrumb: "RemitOne Live Fees",
      title: "RemitOne Live Fees",
      requiresAuth: true,
    },
  },
  {
    path: "/multisave-discount",
    component: () =>
      import("@/components/admin/discount/ManageMultisaveDiscount.vue"),
    meta: {
      breadCrumb: "Manage Multisave Discount",
      title: "Manage Multisave Discount",
      requiresAuth: true,
    },
  },
  {
    path: "/withdraw-request",
    component: () =>
      import("@/components/admin/withdraw-request/WithdrawRequest.vue"),
    meta: {
      breadCrumb: "Withdraw Request",
      title: "Withdraw Request",
      requiresAuth: true,
    },
  },
  {
    path: "/add-amassador",
    component: () =>
      import("@/components/admin/amassador/AddAmassadorComponent.vue"),
    meta: {
      breadCrumb: "Add Amassador",
      title: "Add Amassador",
      requiresAuth: true,
    },
  },
  {
    path: "/id-scan-pdf-report",
    component: () =>
      import("@/components/admin/id_scan_report/IDScanPDFReport.vue"),
    meta: {
      breadCrumb: "ID Scan PDF report",
      title: "ID Scan PDF report",
      requiresAuth: true,
    },
  },
  {
    path: "/add-sffiliate-code",
    component: () =>
      import(
        "@/components/admin/add_affiliate_code/AddAffiliateCodeComponent.vue"
      ),
    meta: {
      breadCrumb: "Add Affiliate Code",
      title: "Add Affiliate Code",
      requiresAuth: true,
    },
  },
  {
    path: "/document-management",
    redirect: "/document-management/list",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Document Management",
      title: "Document Management",
      requiresAuth: true,
    },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/document_management/DocumentListcomponent.vue")
            .default,
        meta: {
          breadCrumb: "Document List",
          title: "Document List",
          requiresAuth: true,
        },
      },
      {
        path: "add",
        name: "document-add",
        component:
          require("@/components/admin/document_management/AddOrEditDocument.vue")
            .default,
        meta: {
          breadCrumb: "Add Document",
          title: "Add Document",
          requiresAuth: true,
        },
      },
      {
        path: "edit",
        name: "document-edit",
        component:
          require("@/components/admin/document_management/AddOrEditDocument.vue")
            .default,
        meta: {
          breadCrumb: "Edit Document",
          title: "Edit Document",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/news-management",
    redirect: "/news-management/category-list",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "News Management",
      title: "News Management",
      requiresAuth: true,
    },
    children: [
      {
        path: "category-list",
        component:
          require("@/components/admin/news_management/NewsCategoryListcomponent.vue")
            .default,
        meta: {
          breadCrumb: "News Category List",
          title: "News Category List",
          requiresAuth: true,
        },
      },
      {
        path: "add-category",
        name: "category-add",
        component:
          require("@/components/admin/news_management/AddOrEditNewsCategory.vue")
            .default,
        meta: {
          breadCrumb: "Add News Category",
          title: "Add News Category",
          requiresAuth: true,
        },
      },
      {
        path: "edit-category",
        name: "category-edit",
        component:
          require("@/components/admin/news_management/AddOrEditNewsCategory.vue")
            .default,
        meta: {
          breadCrumb: "Edit News Category",
          title: "Edit News Category",
          requiresAuth: true,
        },
      },
      {
        path: "news-list",
        component:
          require("@/components/admin/news_management/NewsListcomponent.vue")
            .default,
        meta: {
          breadCrumb: "News List",
          title: "News List",
          requiresAuth: true,
        },
      },
      {
        path: "add-news",
        name: "news-add",
        component:
          require("@/components/admin/news_management/AddOrEditNewsComponent.vue")
            .default,
        meta: { breadCrumb: "Add News", title: "Add News", requiresAuth: true },
      },
      {
        path: "edit-news",
        name: "news-edit",
        component:
          require("@/components/admin/news_management/AddOrEditNewsComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit News",
          title: "Edit News",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/manage-testimonial",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Testimonial",
      title: "Testimonial",
      requiresAuth: true,
    },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/testimonial/ManageTestmonial.vue")
            .default,
        meta: {
          breadCrumb: " List",
          title: "Testimonial List",
          requiresAuth: true,
        },
      },
      {
        path: "create",
        component:
          require("@/components/admin/testimonial/AddTestmonialComponent.vue")
            .default,
        meta: {
          breadCrumb: "Create",
          title: "Create Testimonial",
          requiresAuth: true,
        },
      },
      {
        path: "edit",
        component:
          require("@/components/admin/testimonial/EditTestmonialComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit",
          title: "Edit Testimonial",
          requiresAuth: true,
        },
      },
    ],
  },

  // {
  //     path: '/partner',
  //     component: require('@/components/admin/uikit/RouterView.vue').default,
  //     meta: {breadCrumb: "Partner", title: "Partner"},
  //     children: [
  //         { path: 'transaction-list', component: require('@/components/admin/partner/TransactionListComponent.vue').default, meta: { breadCrumb: "Transaction List", title: "Transaction List" } },
  //         { path: 'transaction-detail',component: require('@/components/admin/partner/TransactionDetailComponent.vue').default, meta: { breadCrumb: "Transaction Detail", title: "Transaction Detail"}},
  //         { path: 'bank-deposit', component: require('@/components/admin/partner/BankDepositComponent.vue').default, meta: { breadCrumb: "Bank Deposit", title: "Bank Deposit" } },
  //         { path: 'bill-company', component: require('@/components/admin/partner/PartnerListComponent.vue').default, meta: { breadCrumb: "Partner List", title: "Partner List" } },
  //         { path: 'add-partner',component: require('@/components/admin/partner/AddPartnerComponent.vue').default, meta: { breadCrumb: "Add Partner", title: "Add Partner"}},
  //     ]
  // },

  {
    path: "/setting",
    component: () => import("@/components/admin/uikit/RouterView.vue"),
    meta: {
      breadCrumb: "Setting",
      requiresAuth: true,
    },
    children: [
      {
        path: "user-list",
        component: () =>
          import("@/components/admin/setting/UserListComponent.vue"),
        meta: {
          breadCrumb: "User List",
          title: "User List",
          requiresAuth: true,
        },
      },
      {
        path: "user-add",
        component: () =>
          import("@/components/admin/setting/AddUserComponent.vue"),
        meta: { breadCrumb: "Add User", title: "Add User", requiresAuth: true },
      },
      {
        path: "channels",
        component: () =>
          import("@/components/admin/setting/ChannelsComponent.vue"),
        meta: { breadCrumb: "Channels", title: "Channels", requiresAuth: true },
      },
      {
        path: "blank-channels",
        component: () =>
          import("@/components/admin/setting/BlankChannelsComponent.vue"),
        meta: { breadCrumb: "Channels", title: "Channels", requiresAuth: true },
      },
      {
        path: "preferences",
        component: () =>
          import("@/components/admin/setting/PreferencesComponent.vue"),
        meta: {
          breadCrumb: "Preferences",
          title: "Preferences",
          requiresAuth: true,
        },
      },
      {
        path: "limits",
        component: () =>
          import("@/components/admin/setting/LimitsComponent.vue"),
        meta: { breadCrumb: "Limits", title: "Limits", requiresAuth: true },
      },
      {
        path: "payouts",
        component: () =>
          import("@/components/admin/setting/PayoutComponent.vue"),
        meta: { breadCrumb: "Payouts", title: "Payouts", requiresAuth: true },
      },
      {
        path: "Profile",
        component: () =>
          import("@/components/admin/setting/MyProfileComponent.vue"),
        meta: {
          breadCrumb: "My Profile",
          title: "Profile",
          requiresAuth: true,
        },
      },
      {
        path: "setup-profile",
        component: () =>
          import("@/components/admin/setting/SetupProfileComponent.vue"),
        meta: {
          breadCrumb: "Set Up Your Profile",
          title: "Set Up Your Profile",
          requiresAuth: true,
        },
      },
      {
        path: "compliance",
        component: () =>
          import("@/components/admin/setting/ComplianceComponent.vue"),
        meta: {
          breadCrumb: "Compliance",
          title: "Compliance",
          requiresAuth: true,
        },
      },
      {
        path: "compliance-requirements",
        component: () =>
          import("@/components/admin/setting/ComRequirementsComponent.vue"),
        meta: {
          breadCrumb: "Registered Sole Proprietorship",
          title: "Compliance",
          requiresAuth: true,
        },
      },
      {
        path: "configuration-management",
        component: () =>
          import("@/components/admin/setting/ConfigurationManagement.vue"),
        meta: {
          breadCrumb: "Configuration Management",
          title: "Configuration Management",
          requiresAuth: true,
        },
      },
      {
        path: "settings",
        component: () =>
          import("@/components/admin/setting/SettingsComponent.vue"),
        meta: {
          breadCrumb: "Global Settings",
          title: "Global Settings",
          requiresAuth: true,
          menu: "settings",
          permissions: ["settings.view"],
        },
      },
    ],
  },
  {
    path: "/user-managment",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "User Management",
      title: "User Management",
      requiresAuth: true,
    },
    children: [
      {
        path: "user-list",
        component:
          require("@/components/admin/user_management/UserListComponent.vue")
            .default,
        meta: {
          breadCrumb: "User List",
          title: "User List",
          requiresAuth: true,
        },
      },
      {
        path: "user-add",
        component:
          require("@/components/admin/user_management/AddUserComponent.vue")
            .default,
        meta: { breadCrumb: "Add User", title: "Add User", requiresAuth: true },
      },
      {
        path: "user-edit",
        component:
          require("@/components/admin/user_management/EditUserComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit User",
          title: "Edit User",
          requiresAuth: true,
        },
      },
      {
        path: "roles",
        component:
          require("@/components/admin/user_management/RoleListComponent.vue")
            .default,
        meta: { breadCrumb: "Roles", title: "Roles", requiresAuth: true },
      },
      {
        path: "roles/create",
        component:
          require("@/components/admin/user_management/CreateRoleComponent.vue")
            .default,
        meta: {
          breadCrumb: "Create Role",
          title: "Create Role",
          requiresAuth: true,
        },
      },
      {
        path: "roles/edit/:role_id?",
        component:
          require("@/components/admin/user_management/EditRoleComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit Role",
          title: "Edit Role",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/coupon-managment",
    component: require("@/components/admin/uikit/RouterView.vue").default,
    meta: {
      breadCrumb: "Coupon Management",
      title: "Coupon Management",
      requiresAuth: true,
    },
    children: [
      {
        path: "list",
        component:
          require("@/components/admin/coupon_managment/CouponCodeListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Coupon List",
          title: "Coupon List",
          requiresAuth: true,
        },
      },
      {
        path: "create",
        component:
          require("@/components/admin/coupon_managment/CreateCouponComponent.vue")
            .default,
        meta: {
          breadCrumb: "Create Coupon",
          title: "Create Coupon",
          requiresAuth: true,
        },
      },
      {
        path: "edit",
        component:
          require("@/components/admin/coupon_managment/EditCouponComponent.vue")
            .default,
        meta: {
          breadCrumb: "Edit Coupon",
          title: "Edit Coupon",
          requiresAuth: true,
        },
      },
      {
        path: "email-coupon",
        component:
          require("@/components/admin/coupon_managment/email/EmailCouponComponent.vue")
            .default,
        meta: {
          breadCrumb: "Email Coupon",
          title: "Email Coupon",
          requiresAuth: true,
        },
      },
      {
        path: "email-coupon/create",
        component:
          require("@/components/admin/coupon_managment/email/CreateEmailCouponComponent.vue")
            .default,
        meta: {
          breadCrumb: "Create Email Coupon",
          title: "Create Email Coupon",
          requiresAuth: true,
        },
      },
      {
        path: "email-coupon-remittergroup",
        component:
          require("@/components/admin/coupon_managment/email_remittergroup/RemitterGroupEmailCoupon.vue")
            .default,
        meta: {
          breadCrumb: "Email Coupon (Remitter group)",
          title: "Email Coupon (Remitter group)",
          requiresAuth: true,
        },
      },
      {
        path: "email-coupon-remittergroup/create",
        component:
          require("@/components/admin/coupon_managment/email_remittergroup/CreateRemitterGroupEmailCoupon.vue")
            .default,
        meta: {
          breadCrumb: "Create Email Coupon (Remitter group)",
          title: "Create Email Coupon (Remitter group)",
          requiresAuth: true,
        },
      },
      {
        path: "share-&-save-coupon",
        component:
          require("@/components/admin/coupon_managment/Share&SaveCouponListComponent.vue")
            .default,
        meta: {
          breadCrumb: "Share & Save Coupon List",
          title: "Share & Save Coupon List",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/admin/page-404",
    component: () =>
      import("@/components/admin/notfound/NotFoundComponent.vue"),
    meta: { title: "No Data Found", breadCrumb: "No Data Found", requiresAuth: true, },
  },

  {
    path: "/bin/list",
    component: require("@/components/admin/bin/BinComponent.vue").default,
    meta: {
      breadCrumb: "Bin List",
      title: "Bin Management",
      requiresAuth: true,
      menu: "bin",
      permissions: ["bin.view"],
    },
  },
  {
    path: "/ip-blocklist/list",
    component: () =>
      import("@/components/admin/ipblocklist/IpBlocklistComponent.vue"),
    meta: {
      breadCrumb: "IP Blocklist",
      title: "IP Blocklist",
      requiresAuth: true,
      menu: "ipblocklist",
      permissions: ["ipblocklist.view"],
    },
  },
  {
    path: "/ai/workspace",
    component: () =>
      import("@/components/admin/ai/AiWorkspaceComponent.vue"),
    meta: {
      breadCrumb: "AI Workspace",
      title: "AI Workspace",
      requiresAuth: true,
      menu: "ai",
      permissions: ["ai.chat.use"],
    },
  },
  {
    // `ai.config.manage`, not `ai.chat.use`: everything on this screen is a money
    // decision — a token allowance, a spend ceiling, a model — and one of them is the
    // kill switch. It stays reachable while the workspace itself is off, otherwise
    // switching the workspace off would hide the only screen that can switch it back.
    path: "/ai/settings",
    component: () => import("@/components/admin/ai/AiSettingsComponent.vue"),
    meta: {
      breadCrumb: "AI Workspace Settings",
      title: "AI Workspace Settings",
      requiresAuth: true,
      // `ai`, not a menu key of its own: the guard checks this against
      // `allowedMenuItems`, which is built from the `module` column on
      // `arch_permissions`, and every `ai.*` permission carries module `ai`. A key
      // nothing grants fails the menu check and redirects, whatever the permissions say.
      menu: "ai",
      // Checked with `hasAnyPermission`, so either grant admits. `ai.skill.manage` is an
      // authoring job — what the assistant is told to be — and someone can hold it
      // without being trusted with a spend ceiling or the kill switch. The panel renders
      // only the tabs the holder's permissions cover, so this widens who reaches the
      // screen without widening what they can do on it.
      permissions: ["ai.config.manage", "ai.skill.manage"],
    },
  },
  {
    path: "/checker/list",
    component: require("@/components/admin/checker/ListComponent.vue").default,
    meta: {
      breadCrumb: "Checker List",
      title: "Reroute Request Management",
      requiresAuth: true,
      menu: "reroute",
      permissions: ["reroute.view"],
    },
  },
  //ui-kit routes
  {
    path: "/admin/uikit",
    component: () => import("@/components/admin/uikit/RouterView.vue"),
    meta: { breadCrumb: "Ui Kit" },
    children: [
      {
        path: "index",
        component: () => import("@/components/admin/uikit/IndexComponent.vue"),
        meta: { breadCrumb: "Index", title: "Dashboard" },
      },
      {
        path: "iot",
        component: () => import("@/components/admin/uikit/IotComponent.vue"),
        meta: { breadCrumb: "Iot Dashboard", title: "Iot Dashboard" },
      },
      {
        path: "app-inbox",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: { breadCrumb: "Inbox" },
        children: [
          {
            path: "",
            component: () =>
              import("@/components/admin/uikit/InboxComponent.vue"),
            meta: { title: "Inbox" },
          },
          {
            path: "compose",
            component: () =>
              import("@/components/admin/uikit/ComposeComponent.vue"),
            meta: { breadCrumb: "Compose", title: "Compose" },
          },
        ],
      },
      {
        path: "app-chat",
        component: () => import("@/components/admin/uikit/ChatComponent.vue"),
        meta: { breadCrumb: "Chat", title: "Chat" },
      },
      {
        path: "app-calendar",
        component: () =>
          import("@/components/admin/uikit/CalendarComponent.vue"),
        meta: { breadCrumb: "Calendar", title: "Calendar" },
      },
      {
        path: "app-contact-grid",
        component: () =>
          import("@/components/admin/uikit/ContactGrideComponent.vue"),
        meta: { breadCrumb: "Contact Card", title: "Contact Card" },
      },
      {
        path: "file-documents",
        component: () =>
          import("@/components/admin/uikit/DocumentsComponent.vue"),
        name: "fdocuments",
        meta: { breadCrumb: "File Documents", title: "File Documents" },
      },
      {
        path: "file-media",
        component: () =>
          import("@/components/admin/uikit/FileMediaComponent.vue"),
        name: "fmedia",
        meta: { breadCrumb: "File Media", title: "File Media" },
      },
      {
        path: "sweet-alert",
        component: () =>
          import("@/components/admin/uikit/SweetAlertComponent.vue"),
        name: "sweetalert",
        meta: { breadCrumb: "Sweet Alert", title: "Sweet Alert" },
      },
      {
        path: "file-images",
        component: () =>
          import("@/components/admin/uikit/FileImageComponent.vue"),
        name: "fimages",
        meta: { breadCrumb: "File Images", title: "File Images" },
      },
      {
        path: "blog-post",
        component: () => import("@/components/admin/uikit/PostComponent.vue"),
        name: "blog_post",
        meta: { breadCrumb: "Blog Post", title: "Blog Post" },
      },
      {
        path: "blog-list",
        component: () => import("@/components/admin/uikit/ListComponent.vue"),
        name: "blog_list",
        meta: { breadCrumb: "Blog List", title: "Blog List" },
      },
      {
        path: "page-lockscreen",
        component: () =>
          import("@/components/admin/uikit/LockscreenComponent.vue"),
        name: "lockscreen",
        meta: { title: "Lockscreen", layout: "auth" },
      },
      {
        path: "page-404",
        component: () =>
          import("@/components/admin/uikit/FourZeroFourComponent.vue"),
        name: "404",
        meta: { title: "404 Page", layout: "auth" },
      },
      {
        path: "page-403",
        component: () =>
          import("@/components/admin/uikit/FourZeroThreeComponent.vue"),
        name: "403",
        meta: { title: "403 Page", layout: "auth" },
      },
      {
        path: "page-500",
        component: () =>
          import("@/components/admin/uikit/FiveZeroZeroComponent.vue"),
        name: "500",
        meta: { title: "500 Page", layout: "auth" },
      },
      {
        path: "page-503",
        component: () =>
          import("@/components/admin/uikit/FiveZeroThreeComponent.vue"),
        name: "503",
        meta: { title: "503 Page", layout: "auth" },
      },
      {
        path: "blog-details",
        component: () =>
          import("@/components/admin/uikit/DetailsComponent.vue"),
        name: "blog_details",
        meta: { breadCrumb: "Blog Details", title: "Blog Details" },
      },
      {
        path: "ui-typography",
        component: () =>
          import("@/components/admin/uikit/TypographyComponent.vue"),
        name: "typography",
        meta: { breadCrumb: "Typography", title: "Typography" },
      },
      {
        path: "ui-tabs",
        component: () => import("@/components/admin/uikit/TabsComponent.vue"),
        meta: { breadCrumb: "Tabs", title: "Tabs" },
      },
      {
        path: "ui-buttons",
        component: () =>
          import("@/components/admin/uikit/ButtonsComponent.vue"),
        meta: { breadCrumb: "Buttons", title: "Buttons" },
      },
      {
        path: "ui-bootstrap",
        component: () =>
          import("@/components/admin/uikit/BootstrapComponent.vue"),
        meta: { breadCrumb: "Bootstrap UI", title: "Bootstrap UI" },
      },
      {
        path: "ui-icons",
        component: () => import("@/components/admin/uikit/IconComponent.vue"),
        meta: { breadCrumb: "Icons", title: "Icons" },
      },
      {
        path: "ui-notifications",
        component: () =>
          import("@/components/admin/uikit/NotificationComponent.vue"),
        meta: { breadCrumb: "Notifications", title: "Notifications" },
      },
      {
        path: "ui-colors",
        component: () => import("@/components/admin/uikit/ColorComponent.vue"),
        meta: { breadCrumb: "Colors", title: "Colors" },
      },
      {
        path: "ui-listgroup",
        component: () =>
          import("@/components/admin/uikit/ListGroupComponent.vue"),
        meta: { breadCrumb: "List Group", title: "List Group" },
      },
      {
        path: "ui-media",
        component: () => import("@/components/admin/uikit/MediaComponent.vue"),
        meta: { breadCrumb: "Media Object", title: "Media Object" },
      },
      {
        path: "ui-modals",
        component: () => import("@/components/admin/uikit/ModalComponent.vue"),
        meta: { breadCrumb: "Modals", title: "Modals" },
      },
      {
        path: "ui-progressbars",
        component: () =>
          import("@/components/admin/uikit/ProgressbarComponent.vue"),
        meta: { breadCrumb: "Progressbar", title: "Progressbar" },
      },
      {
        path: "widgets-data",
        component: () => import("@/components/admin/uikit/DataComponent.vue"),
        meta: { breadCrumb: "Widgets Data", title: "Widgets Data" },
      },
      {
        path: "widgets-weather",
        component: () =>
          import("@/components/admin/uikit/WeatherComponent.vue"),
        meta: { breadCrumb: "Widgets Weather", title: "Widgets Weather" },
      },
      {
        path: "widgets-blog",
        component: () => import("@/components/admin/uikit/BlogComponent.vue"),
        meta: { breadCrumb: "Widgets Blog", title: "Widgets Blog" },
      },
      {
        path: "widgets-ecommerce",
        component: () =>
          import("@/components/admin/uikit/EcommerceComponent.vue"),
        meta: { breadCrumb: "Widgets eCommerce", title: "Widgets eCommerce" },
      },
      {
        path: "page-blank",
        component: () => import("@/components/admin/uikit/BlankComponent.vue"),
        meta: { breadCrumb: "Page Blank", title: "Page Blank" },
      },
      {
        path: "page-profile",
        component: () =>
          import("@/components/admin/uikit/ProfileComponent.vue"),
        meta: { breadCrumb: "User Profile", title: "User Profile" },
      },
      {
        path: "page-profile2",
        component: () =>
          import("@/components/admin/uikit/ProfiletwoComponent.vue"),
        meta: { breadCrumb: "User Profile", title: "User Profile v2" },
      },
      {
        path: "page-gallery",
        component: () =>
          import("@/components/admin/uikit/GalleryComponent.vue"),
        name: "pgallery",
        meta: { breadCrumb: "Gallery", title: "Gallery" },
      },
      {
        path: "page-timeline",
        component: () =>
          import("@/components/admin/uikit/TimelineComponent.vue"),
        name: "ptimeline",
        meta: { breadCrumb: "Timeline", title: "Timeline" },
      },
      //{ path: 'page-pricing', component: PricingComponent, meta: { breadCrumb: "Pricing",title: "Pricing" },},
      {
        path: "page-invoices",
        component: () =>
          import("@/components/admin/uikit/InvoicesComponent.vue"),
        meta: { breadCrumb: "Invoices", title: "Invoices" },
      },
      {
        path: "page-search-results",
        component: () => import("@/components/admin/uikit/SearchComponent.vue"),
        meta: { breadCrumb: "Search Results", title: "Search Results" },
      },
      {
        path: "page-helper-class",
        component: () =>
          import("@/components/admin/uikit/HelperClassComponent.vue"),
        meta: { breadCrumb: "Helper Class", title: "Helper Class" },
      },
      {
        path: "page-teams-board",
        component: () =>
          import("@/components/admin/uikit/TeamsBoardComponent.vue"),
        meta: { breadCrumb: "Teams Board", title: "Teams Board" },
      },
      {
        path: "page-projects-list",
        component: () =>
          import("@/components/admin/uikit/ProjectsListComponent.vue"),
        meta: { breadCrumb: "Projects List", title: "Projects List" },
      },
      {
        path: "page-maintanance",
        component: () =>
          import("@/components/admin/uikit/MaintananceComponent.vue"),
        name: "maintanance",
        meta: { title: "Maintanance" },
      },
      {
        path: "page-testimonials",
        component: () =>
          import("@/components/admin/uikit/TestimonialsComponent.vue"),
        meta: { breadCrumb: "Testimonials", title: "Testimonials" },
      },
      {
        path: "page-faq",
        component: () => import("@/components/admin/uikit/FaqComponent.vue"),
        meta: { breadCrumb: "FAQs", title: "FAQs" },
      },
      {
        path: "forms-validation",
        component: require("@/components/admin/uikit/ValidationComponent.vue")
          .default,
        meta: { breadCrumb: "Form Validation", title: "Form Validation" },
      },
      {
        path: "forms-basic",
        component: () =>
          import("@/components/admin/uikit/BasicFormComponent.vue"),
        meta: {
          breadCrumb: "Basic Form Elements",
          title: "Basic Form Elements",
        },
      },
      {
        path: "table-normal",
        component: () => import("@/components/admin/uikit/NormalComponent.vue"),
        meta: { breadCrumb: "Table Normal", title: "Table Normal" },
      },
      {
        path: "chart-echarts",
        component: () =>
          import("@/components/admin/uikit/EChartsComponent.vue"),
        meta: { breadCrumb: "E-Charts", title: "E-Charts" },
      },
      {
        path: "map-leaflet",
        component: () =>
          import("@/components/admin/uikit/LeafletComponent.vue"),
        meta: { breadCrumb: "Leaflet Map", title: "Leaflet Map" },
      },
    ],
  },
  {
    path: "*",
    redirect: "/page-login",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "",
});
export default router;

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 6000000, // 5min,300000
  startAtIdle: false,
});

// Helper function to find the first accessible route for a user
const findAccessibleRoute = () => {
  const userPermissions = store.state.auth.permissions || [];
  const allowedMenuItems = store.state.auth.allowedMenuItems || [];
  
  // Map of routes to check, in order of preference
  const routesToCheck = [
    { path: "/dashboard", menu: "dashboard", permission: "dashboard.view" },
    { path: "/bin/list", menu: "bin", permission: "bin.view" },
    { path: "/ip-blocklist/list", menu: "ipblocklist", permission: "ipblocklist.view" },
    { path: "/ai/workspace", menu: "ai", permission: "ai.chat.use" },
    { path: "/business/list", menu: "business", permission: ["business.view"] },
    { path: "/offers/list", menu: "business", permission: ["business.view"] },
    { path: "/country/list", permission: ["country.view","country.edit"] },
    { path: "/analytics", menu: "analytics", permission: "analytics.view" },
    { path: "/daily-transaction-tracker", menu: "dailytransaction", permission: "dailytransaction.view" },
    { path: "/business/analytics", menu: "business", permission: "businessanalytics.view" },
    { path: "/transaction/middleware", menu: "transaction", permission: "transaction.view" },
    { path: "/transaction/treasury", menu: "treasurytransaction", permission: "treasurytransaction.view" },
    { path: "/transaction/business", menu: "businesstransaction", permission: "businesstransaction.view" },
    { path: "/holds", menu: "risk", permission: ["hold.view", "hold.confirm", "hold.reverse"] },
    { path: "/statements", menu: "statement", permission: ["statement.view", "statement.generate"] },
    { path: "/checker/list", menu: "reroute", permission: "reroute.view" },
    { path: "/fx-rates", menu: "fxrates", permission: "fxrates.view" },
    { path: "/customer/list", menu: "remitter", permission: "remitter.view" },
    { path: "/beneficiary/all", menu: "receiver", permission: "receiver.view" },
    { path: "/accounts/list", menu: "accounts", permission: ["bank.view","momo.view"] },
    { path: "/setting/settings", menu: "setting", permission: "settings.view" },
    { path: "/internal-users/list", menu: "users", permission: "users.view" },
    { path: "/internal-user-roles/list", menu: "user-roles", permission: "roles.view" }
  ];
  
  // Find first route user has access to
  for (const route of routesToCheck) {
    // Handle both string and array permissions
    let hasPermission = !route.permission;
    if (route.permission) {
      if (Array.isArray(route.permission)) {
        hasPermission = route.permission.some(perm => userPermissions.includes(perm));
      } else {
        hasPermission = userPermissions.includes(route.permission);
      }
    }
    const hasMenuAccess = !route.menu || allowedMenuItems.includes(route.menu);
    
    if (hasPermission && hasMenuAccess) {
      return route.path;
    }
  }
  
  // Fallback to dashboard if no routes found (shouldn't happen)
  return "/dashboard";
};

// Enhanced route guard for dual authentication
router.beforeEach(async (to, from, next) => {
  const [{ default: authService }, { createNavigationGuard }] = await Promise.all([
    import("@/services/auth/authService"),
    import("@/utils/navigationGuard"),
  ]);
  return createNavigationGuard({ authService, store, findAccessibleRoute })(to, from, next);
});
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = ":: PayAngel :: " + to.meta.title;
  });
});
Vue.config.performance = true;
Vue.config.productionTip = false;


// Load initial auth permission data before app start
(async () => {
  console.log("🚀 Initializing application...");

  // Initialize authentication service first (especially MSAL for Entra ID)
  try {
    const { default: authService } = await import("@/services/auth/authService");
    console.log("🔐 Initializing auth service...");
    await authService.initializeAuth();
    console.log("✅ Auth service initialized");
  } catch (error) {
    console.error("❌ Auth service initialization failed:", error);
  }

  // Load auth data from sessionStorage/server on app startup
  // Wait for it to complete before mounting app to avoid race conditions
  await store.dispatch("authpermission/loadAuthData");

  console.log("✅ Application initialized, mounting Vue app...");
  new Vue({
    router: router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
})();
// store.dispatch("authpermission/loadAuthData").then(() => {
//   new Vue({
//     router: router,
//     store,
//     render: (h) => h(App),
//   }).$mount("#app");
// });

// Setup automatic permission refresh
(() => {
  // Refresh permissions every 5 minutes
  const REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes
  let refreshInterval = null;

  const startPeriodicRefresh = () => {
    // Clear any existing interval
    if (refreshInterval) {
      clearInterval(refreshInterval);
    }

    // Only start refresh if user is authenticated
    if (localStorage.getItem("jwtToken")) {
      refreshInterval = setInterval(() => {
        if (localStorage.getItem("jwtToken")) {
          store.dispatch("authpermission/refreshPermissions").catch(err => {
            console.error("Periodic permission refresh failed:", err);
          });
        }
      }, REFRESH_INTERVAL);
    }
  };

  // Refresh permissions when user returns to the tab
  window.addEventListener("focus", () => {
    if (localStorage.getItem("jwtToken")) {
      store.dispatch("authpermission/refreshPermissions").catch(err => {
        console.error("Focus permission refresh failed:", err);
      });
    }
  });

  // Refresh permissions when page becomes visible (mobile/tablet)
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden && localStorage.getItem("jwtToken")) {
      store.dispatch("authpermission/refreshPermissions").catch(err => {
        console.error("Visibility permission refresh failed:", err);
      });
    }
  });

  // Start periodic refresh on app load
  startPeriodicRefresh();

  // Restart periodic refresh after login (via custom event)
  window.addEventListener("user-logged-in", () => {
    startPeriodicRefresh();
  });

  // Stop periodic refresh on logout (via custom event)
  window.addEventListener("user-logged-out", () => {
    if (refreshInterval) {
      clearInterval(refreshInterval);
      refreshInterval = null;
    }
  });
})();